// AI Generated
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { safeClone } from '@client/app/shared/utils/object-utils';

@Component({
    selector: 'table-filters-selector',
    templateUrl: './table-filters-selector.component.html',
    standalone: false,
})
export class TableFiltersSelectorComponent implements OnInit, OnChanges {
    @Input() filters: any;
    @Input() model: any;
    @Input() show: boolean = false;
    @Input() showDropdown?: boolean;
    @Input() selectorItemTemplate?: string;

    @Output() onChanges = new EventEmitter<any>();
    @Output() showDropdownChange = new EventEmitter<boolean>();

    openSubMenu: string | null = null;
    subMenuSearch: string = '';

    constructor (private cdRef: ChangeDetectorRef) {}

    ngOnInit (): void {
        this.showDropdown = this.showDropdown || false;
        this.model = this.model || {};
    }

    ngOnChanges (changes: SimpleChanges): void {
        if (changes.show) {
            setTimeout(() => {
                this.showDropdown = true;
                this.showDropdownChange.emit(this.showDropdown);
            });
        }
    }

    toggleSubFilter (ev: Event, subFilter: string, item: any): void {
        ev.stopPropagation();
        if (this.model[subFilter] === undefined) {
            return;
        }

        if (this.isSubFilterArray(this.filters[subFilter])) {
            this.handleArraySubFilter(subFilter, item);
        } else {
            this.handleObjectSubFilter(subFilter, item);
        }
        this.changes();
    }

    private handleArraySubFilter (subFilter: string, item: any): void {
        const itemIndex = this.model[subFilter].findIndex(i => i.name === item.name);
        if (itemIndex === -1) {
            this.model[subFilter].push(item);
        } else {
            this.model[subFilter].splice(itemIndex, 1);
        }
        this.cdRef.detectChanges();
    }

    private handleObjectSubFilter (subFilter: string, item: any): void {
        if (this.model[subFilter] && this.model[subFilter].length >= 1 && this.model[subFilter][0]?.name === item.name) {
            this.model[subFilter] = null;
        } else {
            this.model[subFilter] = [item];
        }
    }

    private changes (): void {
        this.onChanges.emit({ changes: safeClone(this.model) });
    }

    isSubFilterItemSelected (subFilter: string, item: any): boolean {
        if (this.model[subFilter] === undefined) {
            return false;
        }

        if (this.isSubFilterArray(this.filters[subFilter])) {
            const itemIndex = this.model[subFilter].findIndex(i => i.name === item.name);
            return itemIndex !== -1;
        } else {
            if (this.model[subFilter] && this.model[subFilter].length >= 1) {
                return this.model[subFilter][0]?.name === item.name;
            }
            return false;
        }
    }

    onOverlayClick (): void {
        this.showDropdown = false;
        this.showDropdownChange.emit(this.showDropdown);
        this.openSubMenu = null;
    }

    closeSubMenu (ev: Event): void {
        ev.stopPropagation();
        this.openSubMenu = null;
    }

    isSubFilterArray (subfilter: any): boolean {
        return Array.isArray(subfilter);
    }

    toggleDropdown (): void {
        this.showDropdown = !this.showDropdown;
        this.showDropdownChange.emit(this.showDropdown);
    }

    openSubMenuHandler (name: string): void {
        this.openSubMenu = name;
        this.subMenuSearch = '';
    }

    getFilterKeys (): string[] {
        return Object.keys(this.filters || {});
    }

    getModelKeys (): string[] {
        return Object.keys(this.model || {});
    }

    getFilteredItems (items: any[]): any[] {
        if (!this.subMenuSearch) {
            return items;
        }
        return items.filter(item =>
            item.name && item.name.toLowerCase().includes(this.subMenuSearch.toLowerCase()),
        );
    }

    trackByFn (index: number, item: string): string {
        return item;
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }
}
